import { render } from "./FaqDetails.pug?vue&type=template&id=f1647350&lang=pug"
import script from "./FaqDetails.js?vue&type=script&lang=js"
export * from "./FaqDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__